var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g({staticClass:"center justify-center rounded-circle",style:({ width: _vm.tamanho, height: _vm.tamanho, backgroundColor: _vm.corBackground })},_vm.$listeners),[_c('span',{style:({ color: _vm.corLabel, fontSize: _vm.tamanhoFonte })},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }